import { Fragment, useRef, useState, useEffect } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { useSelector, shallowEqual } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import ActionDialog from '../ActionDialog';
import { Icon } from "helpers/icons";

export default function ConfirmationModal() {
    const [open, setOpen] = useState(true)

    const cancelButtonRef = useRef(null);

    const { confirmationDialogObj } = useSelector(
        ({ providerNote }) => ({
            confirmationDialogObj: providerNote.confirmationDialogObj,
        }),
        shallowEqual
    );

    useEffect(()=>{
        if(confirmationDialogObj && confirmationDialogObj.open){
            setOpen(true);
        }
    }, [confirmationDialogObj]);

    const callSuccessFun = () => {
      if(confirmationDialogObj?.btnOK && typeof confirmationDialogObj?.btnOK.callBackFun === 'function'){
        if (confirmationDialogObj?.btnOK?.callBackFuncParam) {
          confirmationDialogObj?.btnOK.callBackFun(confirmationDialogObj?.btnOK?.callBackFuncParam);
        } else {
          confirmationDialogObj?.btnOK.callBackFun();
        }
      }
    }
    const callCanelFun = () => {
      if(confirmationDialogObj?.btCancel && typeof confirmationDialogObj?.btCancel.callBackFun === 'function'){
        confirmationDialogObj?.btCancel.callBackFun();
      }
    }
    const handleClose = () => {
      setOpen(false);
      callCanelFun();
    }
    const handleDialogClose = () => {
      if (confirmationDialogObj?.closeOnOutsideClick !== false) {
        handleClose();
      }
    }
  return ( 
    confirmationDialogObj?.open && <>
   { !confirmationDialogObj?.dialogType ?
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-[80]" initialFocus={cancelButtonRef} onClose={handleDialogClose} static={confirmationDialogObj?.closeOnOutsideClick === false}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="bg-white px-4 py-8">
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 w-full text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <div className="flex items-start justify-between gap-3">
                        <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                          {confirmationDialogObj?.title ? confirmationDialogObj?.title : 'Confirmation'}
                        </Dialog.Title>
                        {confirmationDialogObj?.showCloseButton && (
                          <button
                            type="button"
                            onClick={handleClose}
                          >
                            <Icon type="cross" size="5" />
                          </button>
                        )}
                      </div>
                      <div className="mt-2">
                        <div className="text-md text-gray-500 py-2">
                            {confirmationDialogObj?.msg ? <div>{ReactHtmlParser(confirmationDialogObj?.msg)}</div>: 'Are you sure you want to delete this record?'}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {confirmationDialogObj?.isBtnHidden ? 
                  null 
                  :
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    {confirmationDialogObj?.type != 'info' ?
                      <>
                        <button
                          type="button"
                          className="inline-flex w-full justify-center rounded-md border border-transparent bg-teal1000 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-teal1100 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                          onClick={() => {setOpen(false); callSuccessFun()}}
                        >
                          {confirmationDialogObj?.btnOK?.text ? confirmationDialogObj?.btnOK?.text : 'Yes'}
                        </button>
                        {!confirmationDialogObj?.skipCancel && <button
                          type="button"
                          className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                          onClick={handleClose}
                          ref={cancelButtonRef}
                        >
                          {confirmationDialogObj?.btCancel?.text ? confirmationDialogObj?.btCancel?.text : 'No'}
                        </button>}
                      </>
                      : 
                      <button
                          type="button"
                          className="mt-3 inline-flex w-full justify-center rounded-md border  border-transparent bg-teal1000 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-teal1100 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                          onClick={() => setOpen(false)}
                          ref={cancelButtonRef}
                        >
                          Ok
                        </button>
                    
                    }
                  </div>
                }
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>: 
       confirmationDialogObj?.dialogType&&
        <ActionDialog
        showModal={open}
        onCancelHandler={()=>{
          setOpen(false)
          if(confirmationDialogObj?.btCancel?.callCanelFun){
            confirmationDialogObj?.btCancel?.callCanelFun();
          }
        }}
        extraButton={confirmationDialogObj?.extraButton}
        headerTitle={confirmationDialogObj?.title ? confirmationDialogObj?.title : 'Confirmation'}
        onConfirmHandler={()=>{setOpen(false); callSuccessFun()}}
        cancelButtonText=  {confirmationDialogObj?.btCancel?.text ? confirmationDialogObj?.btCancel?.text : 'No'}
        confirmButtonText=  {confirmationDialogObj?.btnOK?.text ? confirmationDialogObj?.btnOK?.text : 'Yes'}
        title= {confirmationDialogObj?.msg ? confirmationDialogObj?.msg: 'Are you sure you want to delete this record?'}
        setShowModal={setOpen}
      />
    
    }
    </>
  )
}